import { render, staticRenderFns } from "./prewarninginfo.vue?vue&type=template&id=603171a9&scoped=true"
import script from "./prewarninginfo.vue?vue&type=script&lang=js"
export * from "./prewarninginfo.vue?vue&type=script&lang=js"
import style0 from "./prewarninginfo.vue?vue&type=style&index=0&id=603171a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603171a9",
  null
  
)

export default component.exports